export const CONTAINER_STAGING = 'TASK_STAGING';
export const CONTAINER_STARTING = 'TASK_STARTING';
export const CONTAINER_RUNNING = 'TASK_RUNNING';
export const CONTAINER_KILLING = 'TASK_KILLING';
export const CONTAINER_KILLED = 'TASK_KILLED';
export const CONTAINER_UNREACHABLE = 'TASK_UNREACHABLE';
